import React, { Fragment } from "react";
import { useEffectOnce } from "../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import {
  setProcessing,
  loadPage,
  disposePage,
  setPageValue,
} from "../../redux/slices/onboardingpageslice";
import {
  setCurrentPageIsDirty,
  setCurrentPage,
} from "../../redux/slices/currentpageslice";
import { addNotification } from "../../redux/slices/notificationsslice";
import { notificationDurationMiddle, deepCompare } from "../../lib/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiErrorsHandler, getErrorMessages } from "../../api/httpclient";
import { Page } from "../page";
import { OnBoardingPageBody } from "./onboardingpagebody";
import { BLOCK_DIRTY_MESSAGE } from "../../settings";
import { useTranslation } from "react-i18next";

import "./onboardingpage.css";

export const OnBoardingPage = (props) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.onBoardingPage);
  const currentPageState = useSelector((state) => state.currentPage);
  const currentUser = useSelector((state) => state.currentUser);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const plan = searchParams.get("plan");
  const { t } = useTranslation();

  let currentPageId = "onBoardingPage";

  /*block navigation if dirty*/
  const updateDirtyState = () => {
    //we need to exclude some fields from the state comparison; if the user opens or closes a section, this shall NOT affect isDirty
    let fiv = pageState.formInitialValues;
    let fv = pageState.formValues;

    let isDirty = !deepCompare(fiv, fv);
    //let wasDirty = currentPageState.isDirty;

    dispatch(setCurrentPageIsDirty(isDirty));
  };

  const blockNavigationIfDirty = (msg) => {
    if (currentPageState.isDirty) {
      if (window.confirm(msg ? msg : BLOCK_DIRTY_MESSAGE) == true) {
        dispatch(setCurrentPageIsDirty(false));
        return false;
      } else return true;
    } else return false;
  };
  /*block navigation if dirty*/

  /*initial page load*/
  useEffectOnce(() => {
    if (!plan) {
      navigate("/", { replace: true }); // redirect to home page
      return;
    }
    dispatch(setPageValue({ id: "plan", value: plan }))
    dispatch(loadPage(t));

    return () => {
      dispatch(setCurrentPage({ id: "", isDirty: false }));
      dispatch(disposePage(true));
    };
  }, []);
  /*initial load*/

  return (
    <Fragment>
      <Page
        id="onBoardingPage"
        className="onboarding-page"
        title={t("onboarding.title")}
        animation={props.animation}
      >
        <OnBoardingPageBody updateDirtyState={updateDirtyState} plan={plan} />
      </Page>
      <style>
        {`
                    /*page class*/
                    
                    `}
      </style>
    </Fragment>
  );
};
